var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C15.3137 0 18 2.68629 18 6C18 9.2384 15.4344 11.8776 12.2249 11.9959L12 12H7V14H11C11.5523 14 12 14.4477 12 15C12 15.5523 11.5523 16 11 16H7V19C7 19.5523 6.55228 20 6 20C5.44772 20 5 19.5523 5 19V16H1C0.447715 16 0 15.5523 0 15C0 14.4477 0.447715 14 1 14H5V12H1C0.447715 12 0 11.5523 0 11C0 10.4872 0.38604 10.0645 0.883379 10.0067L1 10H5V1C5 0.447715 5.44772 0 6 0H12ZM12 2H7V10H12C14.2091 10 16 8.20914 16 6C16 3.8578 14.316 2.10892 12.1996 2.0049L12 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuble);
export default __webpack_public_path__ + "static/media/ruble.33c69d40.svg";
export { ForwardRef as ReactComponent };